import React, { Suspense } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore } from "redux";
import { Provider } from "react-redux";
import RootReducers from "./reducers/RootReducers";
import { render } from "react-dom";
const store = createStore(RootReducers);
//const root = ReactDOM.createRoot(document.getElementById('root'));
render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<span>Loading...</span>}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
